var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ReviewUrl)?_c('div',[_c('a',{attrs:{"href":_vm.ReviewUrl,"target":_vm.normalizedLinkTarget},on:{"click":function($event){return _vm.handleClickEvent()}}},[_c('span',[_vm._v("\n            "+_vm._s(_vm.reviewCount)+"\n        ")]),_vm._v("\n        "+_vm._s(_vm.LinkText)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }